module.exports = __webpack_public_path__ + "static/media/excellence-icon.ded52164.svg";